/**
 * The hour tags of ONE SMSWiser campaign (Tag Rules › Hours preview). The key
 * carries "hour-performance-tags", so saving a rule refetches it.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';
import type { HourPerformanceTagsResponse } from '@trafficpulse/shared';

import api from '@/services/api';
import { smswiserKeys, unwrapApiData } from '@/hooks/smswiser/core/useSMSWiser';

export function useHourPerformanceTags(countryKey: string, campaignWiserId: number | null) {
  return useQuery({
    queryKey: [...smswiserKeys.country(countryKey), 'hour-performance-tags', campaignWiserId],
    queryFn: async () => {
      const res = await api.get(
        `/smswiser/countries/${encodeURIComponent(countryKey)}/hour-performance-tags`,
        { params: { wiserIds: String(campaignWiserId) } },
      );
      return unwrapApiData<HourPerformanceTagsResponse>(res.data);
    },
    enabled: Boolean(countryKey) && campaignWiserId != null && campaignWiserId > 0,
    staleTime: 5 * 60 * 1000,
  });
}
